<template>
    <div class="weather-popup" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none'}">

        <div class="background" v-on:click="Close()"></div>
        <div class="pointer" v-bind:class="[pointerDirection]" v-bind:style="{left: pointerOffsetX, top: pointerOffsetY}"></div>
        <div class="header">
            <div class="label"></div>
        </div>
        <div class="fa-stack cancel" v-on:click="Toggle(false)">
            <i class="fas fa-circle fa-stack-2x"></i>
            <i class="fas fa-times fa-stack-2x"></i>
        </div>
        <div class="entry header">
            <div class="fa-stack left" v-on:click="ChangeDate(date.clone().add(-1,'days'))">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-angle-left fa-stack-2x"></i>
            </div>
            <div class="fa-stack right" v-on:click="ChangeDate(date.clone().add(1,'days'))">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-angle-right fa-stack-2x"></i>
            </div>
            <div class="label bold">{{date.format('dddd')}},</div>
            <div class="label">{{date.format('DD')}}. {{date.format('MMMM YYYY')}}</div>
        </div>
        <div class="entry location">
            <div class="line-through"></div>
            <div class="label">&nbsp;&nbsp;NÖ, Hollabrunn&nbsp;&nbsp;</div>
        </div>
        <div class="entry icon">
            <img class="picture" v-bind:src="'img/'+dWeatherCode+'.svg'"/>
            <div class="label">{{dTemp.toString().substring(0,4)}}°</div>
        </div>
        <div class="entry variation">
            <div class="line-through"></div>
            <div class="label">&nbsp;&nbsp;{{dMinTemp}}° / {{dMaxTemp}}°&nbsp;&nbsp;</div>
        </div>
        <div class="entry hourly">
            <div class="slot" v-for="(slot, index) in data" :key="index" v-if="((isAM && index < 12) || (!isAM && index >= 12)) && data.length > 7">
                <div class="label hour">{{index < 10 ? '0' + index : index}}</div>
                <div class="label super">h</div>
                <div class="label rain">{{slot.pop ? slot.pop + '%' : ''}}</div>
                <img class="picture" v-bind:src="'img/'+slot.weatherCode+'.svg'"/>
                <div class="label temp">{{slot.temp}}°</div>
            </div>
        </div>
        <div class="entry nav" v-if="data.length > 7">
            <div class="line-through"></div>
            <div class="fa-stack left" v-on:click="isAM = !isAM">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-angle-left fa-stack-2x"></i>
            </div>
            <div class="fa-stack right" v-on:click="isAM = !isAM">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-angle-right fa-stack-2x"></i>
            </div>
        </div>
        <div class="entry info">
            <div class="label">Niederschlag: {{dPop}}%</div>
        </div>
        <div class="entry info">
            <div class="label">Luftfeuchtigkeit: {{dHumidity}}%</div>
        </div>
        <div class="entry info">
            <div class="label">Wind: {{dWindSpd}}km/h</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'weatherpopup',
        components: {
        },
        data(){
            return{
                toggled: false,
                posxstart: 0,
                posystart: 0,
                posx: 0,
                posy: 0,
                width: 0,
                height: 0,
                appendedData: {},
                pointerDirection: 'top',
                elRelative: null,
                date: moment(),
                rawData: [],
                data: [],
                dMinTemp: 0,
                dMaxTemp: 0,
                dTemp: 0,
                dPop: 0,
                dWindSpd: 0.0,
                dHumidity: 0,
                dWeatherCode: "01",
                isAM: true,
                pointerOffsetX: '',
                pointerOffsetY: '',
            }
        },
        created () {
            var view = this;
            this.toggled = false;
            window.addEventListener('resize', this.Reposition);
        },
        destroyed(){
            window.removeEventListener('resize', this.Reposition);
        },
        methods: {
            Close(){
                this.Toggle(false);
            },
            Toggle(val){
                if(val !== undefined || val !== null) {
                    if(!val) this.selected = null;
                    this.toggled = val;
                    return;
                }
                this.toggled = !this.toggled;
                if(!this.toggled) this.selected = null;
            },
            Reposition(){
                var view = this;
                requestAnimationFrame(function(){
                    if(!view.elRelative) return;
                    var box = view.elRelative.getBoundingClientRect();
                    var widthTotal = window.innerWidth;
                    var heightTotal = window.innerHeight;
                    var posx = 0;
                    var posy = 0;
                    var userselectwidth = 400;
                    var userselectheight = 520;
                    var offsety = 20;
                    var offsetyBottom = 70;
                    view.pointerOffsetX = '';
                    if(widthTotal - (box.left + (box.width / 2)) > (userselectwidth / 2)) {
                        posx = (box.left + (box.width / 2)) - (userselectwidth / 2);
                    } else {
                        requestAnimationFrame(function(){
                            var popupBox = view.$el.getBoundingClientRect();
                            var pointerBox = $(view.$el).find('.pointer')[0].getBoundingClientRect();
                            var pointerOffsetX = (((box.left + (box.width / 2)) - ((popupBox.left + popupBox.right) / 2)) / .4);
                            if(pointerOffsetX + (pointerBox.width + 20) > (userselectwidth)) pointerOffsetX = (userselectwidth) - (pointerBox.width  + 20);
                            view.pointerOffsetX = pointerOffsetX + 'px';
                        });
                        if(box.left < 150 || widthTotal < (userselectwidth / 2)) {
                            posx = 5;
                        } else {
                            posx = widthTotal - userselectwidth - 5;
                        }
                    }
                    var pointerDirection = 'top';
                    if(heightTotal - (box.top + box.height + offsety) > userselectheight) {
                        posy = (box.top + box.height + offsety);
                    } else {
                        if(heightTotal < userselectheight || box.top - offsetyBottom - userselectheight < 0) {
                            posy = 5;
                            pointerDirection = 'hide';
                        } else {
                            posy = box.top - offsetyBottom - userselectheight;
                            pointerDirection = 'bottom';
                        }
                    }
                    view.posx = posx;
                    view.posy = posy;
                    view.pointerDirection = pointerDirection;
                    view.$forceUpdate();
                });
            },
            ChangeDate(newDate){
                    if(this.rawData.filter(d => moment.unix(d.dt).date() === newDate.date()).length === 0) return;
                    this.date = newDate;
                    this.date.locale('de');

                    this.InitData();
            },
            Init(options){
                var view = this;
                if(options.elRelative){
                    this.elRelative = options.elRelative
                    this.Reposition();
                }
                if(options.data){
                    this.rawData = options.data;
                }
                if(options.date){
                        this.date = options.date;
                        this.date.locale('de');
                        this.InitData();
                    }
                this.toggled = true;
            },
            InitData(){
                var view = this;
                this.data = this.rawData.filter(d => moment.unix(d.dt).date() === view.date.date());

                this.dWeatherCode = this.data[0].dWeatherCode;
                var dTemp = this.rawData.find(d => d.date.date() === view.date.date() && d.dTemp && !isNaN(d.dTemp));
                if(dTemp) this.dTemp = dTemp.dTemp;
                var dMinTemp = this.rawData.find(d => d.date.date() === view.date.date() && d.dMinTemp && !isNaN(d.dMinTemp));
                if(dMinTemp) this.dMinTemp = dMinTemp.dMinTemp;
                var dMaxTemp = this.rawData.find(d => d.date.date() === view.date.date() && d.dMaxTemp && !isNaN(d.dMaxTemp));
                if(dMaxTemp) this.dMaxTemp = dMaxTemp.dMaxTemp;
                var dPop = this.rawData.find(d => d.date.date() === view.date.date() && d.dPop && !isNaN(d.dPop));
                if(dPop) this.dPop = dPop.dPop;
                var dHumidity = this.rawData.find(d => d.date.date() === view.date.date() && d.dHumidity && !isNaN(d.dHumidity));
                if(dHumidity) this.dHumidity = dHumidity.dHumidity;
                var dWindSpd = this.rawData.find(d => d.date.date() === view.date.date() && d.dWindSpd && !isNaN(d.dWindSpd));
                if(dWindSpd) this.dWindSpd = dWindSpd.dWindSpd;

                if(this.data.length > 7)
                {
                    var tempData = [];
                    for(var x = 0; x < 24; x++){
                        if(this.data.find(d => d.date.hours() === x)) tempData.push(this.data.find(d => d.date.hours() === x));
                        else if(this.data.find(d => d.date.hours() > x)) tempData.push(this.data.find(d => d.date.hours() > x));
                        else if(this.data.find(d => d.date.hours() < x)) tempData.push(this.data.find(d => d.date.hours() < x));

                        tempData[x].temp = tempData[x].dTemp = isNaN(tempData[x].dTemp) ? tempData[x].temp : tempData[x].dTemp;
                        tempData[x].tempMin = tempData[x].dMinTemp = isNaN(tempData[x].dMinTemp) ? tempData[x].tempMin : tempData[x].dMinTemp;
                        tempData[x].tempMax = tempData[x].dMaxTemp = isNaN(tempData[x].dMaxTemp) ? tempData[x].tempMax : tempData[x].dMaxTemp;
                    }
                    this.data = tempData.slice();
                }
            },

        },
        mounted() {
            $('body').append(this.$el);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .weather-popup{
        position:fixed;
        display:inline-block;
        /*height: 520px;*/
        width: 400px;
        border-radius: 5px;
        display:none;
        z-index: 1000;
        background: white;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        padding: 30px;
    }
     .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }

    .header{
    }
    .header .label{
        box-shadow: inset 0 -1px 0 0px #ebebeb;
        font-size: 30px;

    }

    .fa-stack.cancel{
        cursor: pointer;
        position: absolute;
        top: 6px;
        right: 5px;
        font-size: 10px;
        transform: scale(.8);
    }
    .fa-stack.cancel .fa-circle{
    }
    .fa-stack.cancel .fa-times{
        font-size: 13px;
        transform: translateY(3px);
    }

    .weather-popup > .label{
        color: #cccccc;
        font-size: 11px;
        font-weight: 500;
        position: absolute;
        margin-top: -10px;
    }
    .weather-popup > .label.second{

        margin-top: 5px;
    }


    .label{
        background: white;
    }
    .entry .label{

        font-weight: 200;
    }
    .entry > .label{
        padding: 0 5px;
    }
    .entry{
        width: 100%;
        text-align: center;
        display: table;
        position: relative;
    }


    .entry.header{
        box-shadow: none;
        float: none;
        margin-top: 15px;
    }

    .entry.header .fa-stack{

    }

    .entry.header .label{
        box-shadow: none;
        color: #404040;
        float: none;
        font-size: 14px;
        font-family: DistrictProLight;
        letter-spacing: 0.2px;
        margin-left: -6px;
    }

    .entry.header .label.bold{
        font-weight: 700;
        font-family: DistrictProBold;
        letter-spacing: 1.2px;
        margin-left: -5px;
    }

    .entry.icon{
    }
    .entry.icon .picture{
        height: 80px;
        margin-top: -40px;
    }
    .entry.icon .label{
        font-size: 60px;
        font-family: DistrictProLight;
        color: #808080;
        margin: 7px 0px 10px 5px;
        letter-spacing: 0px;
        font-weight: 200;
    }


    .entry.variation{
    margin-top: 0px;
    }

    .entry.location{
        margin-top: 10px;
        letter-spacing: 0px;
    }

    .entry.hourly{
    padding-top: 13px;

    }
    .entry.hourly .slot{
        width: 20px;
        margin: 0px 2.5px;
        display: inline-block;
    }
    .entry.hourly .slot > *{
        float: left;
    }

    .entry.hourly .slot .hour{

    }
    .entry.hourly .slot .super{
        font-size: 8px;
        transform: translate(1px, -2px);
    }
    .entry.hourly .slot .picture{
        height: 14px;
    margin: 0px -2px 10px;
    }
    .entry.hourly .slot .temp{

    width: 16px;
    margin-top: 4px;
    }
    .entry.hourly .slot .rain{
        color: #08a1e4;
        font-size: 7px;
        height: 10px;
        width: 100%;
        -webkit-transform: translate(-4px, 3px);
        transform: translate(-2px, 2px);
    }

    .entry.nav{
        margin: 12px 0;
    }
    .entry.nav .fa-stack{
    transform: scale(0.45);
        cursor:pointer;
    }

    .entry.nav .left{
        left: -25px;
        right: 0;
        top: 3px;
        bottom: 0;
        margin:auto;
        background: white;
        width: 75px;
    }
    .entry.nav .right{
        right: -25px;
        left: 0;
        top: 3px;
        bottom: 0;
        margin:auto;
        background: white;
        width: 75px;
    }


    .entry.nav .fa-angle-right, .entry.nav .fa-angle-left{
        pointer-events:none;
    }

    .entry.info{
    }

    .entry.info .label{
        font-family: DistrictProLight;
        width: 100%;
        font-size: 13px;
        letter-spacing: 0.3px;
        color: #808080;
        margin-left: 12px;
        margin-bottom: 6px;
        margin-top: 4px;
    }

    .entry.location .label, .entry.variation .label, .entry.hourly .label.hour, .entry.hourly .label.temp, .entry.nav .label {
        font-size: 10px;
        color: #808080;
    }

    .left{
        position:absolute;
        margin: 0;
        top: 0px;
        transform: scale(0.7);
        left: 0;
        cursor:pointer;
    }
    .right{
        position:absolute;
        margin: 0;
        top: 0px;
        transform: scale(0.7);
        right: 0;
        cursor:pointer;
    }
    .line-through{
        top: 2px;
        bottom: 0;
        margin: auto;
        width: 100%;
        height: 1px;
        background: #c1c1c1;
        position: absolute;

        z-index: -1;
    }

    .divider{
        width: 100%;
        margin: 15px 0;
        border-bottom: 1px solid #e5e5e5;
    }

    .pointer{
        position: absolute;
        right: 0;
        left: 0;
        margin: auto;
        width: 0;
    }

    .pointer:before{
        content:'';
        position: absolute;
        top: 1px;
        left: -13px;
        z-index: -1;
        filter: blur(5px);
    }

    .pointer:after{
        content:'';
        position: absolute;
        left: -20px;
        background: white;
        width: 40px;
        height: 20px;
        z-index: -1;
    }

    .pointer.top{
        top: -15px;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-bottom: 15px solid white;
    }
    .pointer.top:before{
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-bottom: 15px solid rgba(0,0,0,.2);
    }
    .pointer.top:after{
        top: 15px;
    }
    .pointer.bottom{
        bottom: -15px;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-top: 15px solid white;
    }
    .pointer.bottom:before{
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        top: initial;
        bottom: 1px;
    }
    .pointer.bottom:after{
        bottom: 15px;
    }

    .pointer.hide{
        display: none;
    }

    .nightmode .pointer:after{
        background: var(--sub-menu);
    }

    .nightmode .pointer.top{
        border-bottom: 15px solid var(--sub-menu);
    }
    .nightmode .pointer.bottom{
        border-top: 15px solid var(--sub-menu);
    }


    .nightmode .left, .nightmode .right{
        background: var(--sub-menu) !important;
    }


    .nightmode .weather-popup{
        background: var(--sub-menu);
    }



    .nightmode .label{
        background: var(--sub-menu);
        color: var(--contrast-4) !important;
    }


</style>
